import SLSParametrosClient from '@/api/SistemaDKP/sls-parametros.client';

const PARAM_RASCUNHO = 'RASCUNHO_PEDIDO_ATIVO';
const PARAM_RASCUNHO_APENAS_DOACAO = 'RASCUNHO_APENAS_DOACAO';
const PARAM_RASCUNHO_PERFIS = 'RASCUNHO_PEDIDO_PERFIS';
const PARAM_ESTOQUE = 'CONTROLE_ESTOQUE_ATIVO';
const PARAM_BLOQUEAR_ESTOQUE = 'BLOQUEAR_VENDA_SEM_ESTOQUE';
const PARAM_COMISSOES = 'COMISSOES_ATIVO';
const PARAM_SOLICITACAO_DEVOLUCAO = 'SOLICITACAO_DEVOLUCAO_ATIVO';
const PARAM_CADASTRO_CLIENTE = 'CADASTRO_CLIENTE_ATIVO';
const PARAM_BLOQUEAR_PEDIDO_MINIMO = 'BLOQUEAR_PEDIDO_MINIMO';
const PARAM_CLIENTE_OCULTAR_INFO_COMERCIAL = 'CLIENTE_OCULTAR_INFO_COMERCIAL';
const PARAM_REPRESENTANTE_OCULTAR_INFO_COMERCIAL = 'REPRESENTANTE_OCULTAR_INFO_COMERCIAL';
const PARAM_SUPERVISOR_OCULTAR_INFO_COMERCIAL = 'SUPERVISOR_OCULTAR_INFO_COMERCIAL';
const PARAM_PIC = 'PIC_ATIVO';
const PARAM_CRM = 'CRM_ATIVO';

const truthy = (v) => {
  if (v === true) return true;
  if (v == null) return false;
  const s = String(v).trim().toLowerCase();
  return s === 's' || s === 'sim' || s === 'true' || s === '1' || s === 'y' || s === 'yes';
};

export default {
  namespaced: true,
  state: () => ({
    exibirDataPrevistaEntrega: true,
    loaded: false,
    loading: false,
    rascunhoAtivo: false,
    // Quando ativo, rascunho só é permitido para pedidos de doação (WD).
    rascunhoApenasDoacao: false,
    // Nomes de perfis autorizados a usar rascunho (CSV do parâmetro).
    // Lista vazia = todos os perfis (comportamento histórico).
    rascunhoPerfis: [],
    // Nome do perfil ativo (espelho REATIVO do localStorage 'perfilLogado').
    // Precisa viver no state: getters Vuex são cacheados por dependências
    // reativas — ler o localStorage direto no getter deixava o valor do
    // usuário anterior cacheado após logout/login sem recarregar a página.
    perfilNome: '',
    controleEstoqueAtivo: true,
    bloquearVendaSemEstoque: false,
    comissoesAtivo: true,
    solicitacaoDevolucaoAtivo: true,
    cadastroClienteAtivo: false,
    // Padrão: bloqueia pedidos abaixo do valor mínimo (comportamento histórico).
    // Quando desativado, o pedido é permitido com um aviso de confirmação.
    bloquearPedidoMinimo: true,
    // Quando ativo, o perfil Cliente não vê representante, condição de
    // pagamento e tabela de preço (visual apenas; lógica inalterada).
    clienteOcultarInfoComercial: false,
    // Quando ativo, o perfil Representante não vê tabela de preço e condição
    // de pagamento (visual apenas; lógica inalterada).
    representanteOcultarInfoComercial: false,
    // Quando ativo, o perfil Supervisor não vê tabela de preço e condição
    // de pagamento (visual apenas; lógica inalterada).
    supervisorOcultarInfoComercial: false,
    // Funcionalidade PIC (painel, cadastros e modais). Desligada por padrão:
    // parâmetro ausente = PIC oculto.
    picAtivo: false,
    // Módulo CRM (menu, telas). LIGADO por padrão: parâmetro ausente = CRM
    // visível; a empresa desativa criando CRM_ATIVO = N em Parâmetros.
    crmAtivo: true,
    condicaoPagamentoAtiva: true,
  }),
  getters: {
    exibirDataPrevistaEntrega: (state) => state.exibirDataPrevistaEntrega !== false,
    condicaoPagamentoAtiva: state => state.condicaoPagamentoAtiva,
    rascunhoAtivo: (state) => state.rascunhoAtivo === true,
    rascunhoApenasDoacao: (state) => state.rascunhoApenasDoacao === true,
    rascunhoPerfis: (state) => state.rascunhoPerfis,
    // Rascunho habilitado E o perfil ativo do usuário está autorizado.
    rascunhoPermitido: (state) => {
      if (state.rascunhoAtivo !== true) return false;
      if (!state.rascunhoPerfis.length) return true;
      const nome = String(state.perfilNome || '').trim().toLowerCase();
      return !!nome && state.rascunhoPerfis.includes(nome);
    },
    controleEstoqueAtivo: (state) => state.controleEstoqueAtivo === true,
    bloquearVendaSemEstoque: (state) => state.controleEstoqueAtivo === true && state.bloquearVendaSemEstoque === true,
    comissoesAtivo: (state) => state.comissoesAtivo === true,
    solicitacaoDevolucaoAtivo: (state) => state.solicitacaoDevolucaoAtivo === true,
    cadastroClienteAtivo: (state) => state.cadastroClienteAtivo === true,
    bloquearPedidoMinimo: (state) => state.bloquearPedidoMinimo === true,
    clienteOcultarInfoComercial: (state) => state.clienteOcultarInfoComercial === true,
    representanteOcultarInfoComercial: (state) => state.representanteOcultarInfoComercial === true,
    supervisorOcultarInfoComercial: (state) => state.supervisorOcultarInfoComercial === true,
    picAtivo: (state) => state.picAtivo === true,
    crmAtivo: (state) => state.crmAtivo === true,
    loaded: (state) => state.loaded,
  },
  mutations: {
    SET_EXIBIR_DATA_PREVISTA_ENTREGA(state, value) {
      state.exibirDataPrevistaEntrega = value !== false;
    },
    SET_CONDICAO_PAGAMENTO(state, value) { state.condicaoPagamentoAtiva = !!value; },
    SET_RASCUNHO(state, value) {
      state.rascunhoAtivo = !!value;
    },
    SET_RASCUNHO_APENAS_DOACAO(state, value) {
      state.rascunhoApenasDoacao = !!value;
    },
    SET_PERFIL_NOME(state, value) {
      state.perfilNome = String(value || '');
    },
    SET_RASCUNHO_PERFIS(state, value) {
      state.rascunhoPerfis = Array.isArray(value)
        ? value.map((v) => String(v).trim().toLowerCase()).filter(Boolean)
        : String(value || '').split(',').map((v) => v.trim().toLowerCase()).filter(Boolean);
    },
    SET_CONTROLE_ESTOQUE(state, value) {
      state.controleEstoqueAtivo = !!value;
    },
    SET_BLOQUEAR_ESTOQUE(state, value) {
      state.bloquearVendaSemEstoque = !!value;
    },
    SET_COMISSOES(state, value) {
      state.comissoesAtivo = !!value;
    },
    SET_SOLICITACAO_DEVOLUCAO(state, value) {
      state.solicitacaoDevolucaoAtivo = !!value;
    },
    SET_CADASTRO_CLIENTE(state, value) {
      state.cadastroClienteAtivo = !!value;
    },
    SET_BLOQUEAR_PEDIDO_MINIMO(state, value) {
      state.bloquearPedidoMinimo = !!value;
    },
    SET_CLIENTE_OCULTAR_INFO_COMERCIAL(state, value) {
      state.clienteOcultarInfoComercial = !!value;
    },
    SET_REPRESENTANTE_OCULTAR_INFO_COMERCIAL(state, value) {
      state.representanteOcultarInfoComercial = !!value;
    },
    SET_SUPERVISOR_OCULTAR_INFO_COMERCIAL(state, value) {
      state.supervisorOcultarInfoComercial = !!value;
    },
    SET_PIC(state, value) {
      state.picAtivo = !!value;
    },
    SET_CRM(state, value) {
      state.crmAtivo = !!value;
    },
    SET_LOADED(state, value) {
      state.loaded = !!value;
    },
    SET_LOADING(state, value) {
      state.loading = !!value;
    },
  },
  actions: {
    async load({ commit, state }, payload = {}) {
      // Sempre re-sincroniza o perfil ativo a partir do localStorage — mesmo
      // quando os parâmetros já estão carregados (troca de usuário na mesma
      // sessão SPA muda o perfil sem mudar os parâmetros).
      let perfilNome = '';
      try {
        perfilNome = String((JSON.parse(localStorage.getItem('perfilLogado') || '{}') || {}).perfil_acesso_nome || '');
      } catch (e) { perfilNome = ''; }
      commit('SET_PERFIL_NOME', perfilNome);
      if (state.loaded && !payload.force) return;
      if (state.loading) return;
      commit('SET_LOADING', true);
      try {
        const client = new SLSParametrosClient();
        const respCondicao = await client.findByDescricao('CONDICAO_PAGAMENTO_ATIVA');
        const rowCondicao = respCondicao?.data || respCondicao;
        commit('SET_CONDICAO_PAGAMENTO', rowCondicao?.parametro_valor == null || truthy(rowCondicao.parametro_valor));
        const [respRascunho, respRascDoacao, respRascPerfis, respEstoque, respBloq, respComissoes, respSolicDevol, respCadCliente, respBloqMinimo, respOcultarInfo, respOcultarInfoRep, respOcultarInfoSup, respPic, respCrm, respDataPrevista] = await Promise.all([
          client.findByDescricao(PARAM_RASCUNHO).catch(() => null),
          client.findByDescricao(PARAM_RASCUNHO_APENAS_DOACAO).catch(() => null),
          client.findByDescricao(PARAM_RASCUNHO_PERFIS).catch(() => null),
          client.findByDescricao(PARAM_ESTOQUE).catch(() => null),
          client.findByDescricao(PARAM_BLOQUEAR_ESTOQUE).catch(() => null),
          client.findByDescricao(PARAM_COMISSOES).catch(() => null),
          client.findByDescricao(PARAM_SOLICITACAO_DEVOLUCAO).catch(() => null),
          client.findByDescricao(PARAM_CADASTRO_CLIENTE).catch(() => null),
          client.findByDescricao(PARAM_BLOQUEAR_PEDIDO_MINIMO).catch(() => null),
          client.findByDescricao(PARAM_CLIENTE_OCULTAR_INFO_COMERCIAL).catch(() => null),
          client.findByDescricao(PARAM_REPRESENTANTE_OCULTAR_INFO_COMERCIAL).catch(() => null),
          client.findByDescricao(PARAM_SUPERVISOR_OCULTAR_INFO_COMERCIAL).catch(() => null),
          client.findByDescricao(PARAM_PIC).catch(() => null),
          client.findByDescricao(PARAM_CRM).catch(() => null),
          client.findByDescricao('EXIBIR_DATA_PREVISTA_ENTREGA', true).catch(() => null),
        ]);
        const rowDataPrevista = respDataPrevista?.data || respDataPrevista;
        commit('SET_EXIBIR_DATA_PREVISTA_ENTREGA', rowDataPrevista?.parametro_valor == null || truthy(rowDataPrevista.parametro_valor));
        const rowRasc = respRascunho?.data || respRascunho;
        commit('SET_RASCUNHO', truthy(rowRasc?.parametro_valor));
        const rowRascDoacao = respRascDoacao?.data || respRascDoacao;
        commit('SET_RASCUNHO_APENAS_DOACAO', truthy(rowRascDoacao?.parametro_valor));
        const rowRascPerfis = respRascPerfis?.data || respRascPerfis;
        commit('SET_RASCUNHO_PERFIS', rowRascPerfis?.parametro_valor || '');
        const rowEst = respEstoque?.data || respEstoque;
        if (rowEst && rowEst.parametro_valor != null) {
          commit('SET_CONTROLE_ESTOQUE', truthy(rowEst.parametro_valor));
        } else {
          commit('SET_CONTROLE_ESTOQUE', true);
        }
        const rowBloq = respBloq?.data || respBloq;
        commit('SET_BLOQUEAR_ESTOQUE', truthy(rowBloq?.parametro_valor));
        const rowCom = respComissoes?.data || respComissoes;
        if (rowCom && rowCom.parametro_valor != null) {
          commit('SET_COMISSOES', truthy(rowCom.parametro_valor));
        } else {
          commit('SET_COMISSOES', true);
        }
        const rowSolicDevol = respSolicDevol?.data || respSolicDevol;
        if (rowSolicDevol && rowSolicDevol.parametro_valor != null) {
          commit('SET_SOLICITACAO_DEVOLUCAO', truthy(rowSolicDevol.parametro_valor));
        } else {
          commit('SET_SOLICITACAO_DEVOLUCAO', true);
        }
        const rowCadCliente = respCadCliente?.data || respCadCliente;
        commit('SET_CADASTRO_CLIENTE', truthy(rowCadCliente?.parametro_valor));
        const rowBloqMinimo = respBloqMinimo?.data || respBloqMinimo;
        if (rowBloqMinimo && rowBloqMinimo.parametro_valor != null) {
          commit('SET_BLOQUEAR_PEDIDO_MINIMO', truthy(rowBloqMinimo.parametro_valor));
        } else {
          // Parâmetro ausente → mantém o comportamento histórico (bloquear)
          commit('SET_BLOQUEAR_PEDIDO_MINIMO', true);
        }
        const rowOcultarInfo = respOcultarInfo?.data || respOcultarInfo;
        // Ausente → comportamento histórico (mostrar as informações)
        commit('SET_CLIENTE_OCULTAR_INFO_COMERCIAL', truthy(rowOcultarInfo?.parametro_valor));
        const rowOcultarInfoRep = respOcultarInfoRep?.data || respOcultarInfoRep;
        // Ausente → comportamento histórico (mostrar as informações)
        commit('SET_REPRESENTANTE_OCULTAR_INFO_COMERCIAL', truthy(rowOcultarInfoRep?.parametro_valor));
        const rowOcultarInfoSup = respOcultarInfoSup?.data || respOcultarInfoSup;
        // Ausente → comportamento histórico (mostrar as informações)
        commit('SET_SUPERVISOR_OCULTAR_INFO_COMERCIAL', truthy(rowOcultarInfoSup?.parametro_valor));
        const rowPic = respPic?.data || respPic;
        // Ausente → PIC desligado (padrão)
        commit('SET_PIC', truthy(rowPic?.parametro_valor));
        const rowCrm = respCrm?.data || respCrm;
        // Ausente → CRM ligado (padrão); só desliga com valor explícito falso.
        if (rowCrm && rowCrm.parametro_valor != null) {
          commit('SET_CRM', truthy(rowCrm.parametro_valor));
        } else {
          commit('SET_CRM', true);
        }
        commit('SET_LOADED', true);
      } catch (e) {
        commit('SET_EXIBIR_DATA_PREVISTA_ENTREGA', true);
        commit('SET_CONDICAO_PAGAMENTO', true);
        commit('SET_RASCUNHO', false);
        commit('SET_RASCUNHO_APENAS_DOACAO', false);
        commit('SET_RASCUNHO_PERFIS', []);
        commit('SET_CONTROLE_ESTOQUE', true);
        commit('SET_BLOQUEAR_ESTOQUE', false);
        commit('SET_COMISSOES', true);
        commit('SET_SOLICITACAO_DEVOLUCAO', true);
        commit('SET_CADASTRO_CLIENTE', false);
        commit('SET_BLOQUEAR_PEDIDO_MINIMO', true);
        commit('SET_CLIENTE_OCULTAR_INFO_COMERCIAL', false);
        commit('SET_REPRESENTANTE_OCULTAR_INFO_COMERCIAL', false);
        commit('SET_SUPERVISOR_OCULTAR_INFO_COMERCIAL', false);
        commit('SET_PIC', false);
        commit('SET_CRM', true);
        commit('SET_LOADED', true);
      } finally {
        commit('SET_LOADING', false);
      }
    },
    reset({ commit }) {
      commit('SET_EXIBIR_DATA_PREVISTA_ENTREGA', true);
      commit('SET_CONDICAO_PAGAMENTO', true);
      commit('SET_RASCUNHO', false);
      commit('SET_RASCUNHO_APENAS_DOACAO', false);
      commit('SET_RASCUNHO_PERFIS', []);
      commit('SET_CONTROLE_ESTOQUE', true);
      commit('SET_BLOQUEAR_ESTOQUE', false);
      commit('SET_COMISSOES', true);
      commit('SET_SOLICITACAO_DEVOLUCAO', true);
      commit('SET_CADASTRO_CLIENTE', false);
      commit('SET_BLOQUEAR_PEDIDO_MINIMO', true);
      commit('SET_CLIENTE_OCULTAR_INFO_COMERCIAL', false);
      commit('SET_REPRESENTANTE_OCULTAR_INFO_COMERCIAL', false);
      commit('SET_SUPERVISOR_OCULTAR_INFO_COMERCIAL', false);
      commit('SET_PIC', false);
      commit('SET_CRM', true);
      commit('SET_LOADED', false);
    },
  },
};
